import React from 'react';
import {Form, useUpdateFormMutation} from 'api';
import {useForm} from 'react-hook-form';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import debounce from 'helpers/debounce';

interface Props {
  form: Form;
}

export default ({form}: Props) => {
  const [updateForm] = useUpdateFormMutation({refetchQueries: ['form']});

  const {register, watch, handleSubmit} = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        formInputBorderColor: Yup.string().required(),
      }),
    ),
    defaultValues: {
      formInputBorderColor: form.formInputBorderColor || 'var(--border-color)',
    },
    mode: 'onChange',
  });

  const onSubmit = debounce((data: any) => {
    updateForm({
      variables: {
        uuid: form.uuid,
        attributes: data,
      },
    });
  }, 500);

  React.useEffect(() => {
    const subscription = watch(() => handleSubmit(onSubmit)());
    return () => subscription.unsubscribe();
  }, [handleSubmit, watch]);

  return (
    <div className="flex flex-col gap-1">
      <label className="tracking-wide font-medium text-base text-c-light">
        枠カラー
      </label>
      <input
        className="bg-white text-base block w-full border border-c-border rounded"
        type="color"
        {...register('formInputBorderColor')}
      />
    </div>
  );
};
